// Mock data for Embrace the Magic of Words

export const tptProducts = [
  {
    id: 1,
    title: "Vocabulary Building Workbook - Level 1",
    description: "Engaging vocabulary exercises for early learners with tracing activities and visual aids.",
    price: "$4.99",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=400&h=300&fit=crop",
    category: "Vocabulary",
    grades: "K-2"
  },
  {
    id: 2,
    title: "ESL Word Builder Pack",
    description: "Comprehensive resource for ESL/ELL students featuring interactive word-building activities.",
    price: "$6.99",
    image: "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?w=400&h=300&fit=crop",
    category: "ESL/ELL",
    grades: "1-4"
  },
  {
    id: 3,
    title: "SPED Language Development Kit",
    description: "Specially designed materials for SPED students with differentiated learning approaches.",
    price: "$7.99",
    image: "https://images.unsplash.com/photo-1471666875520-c75081f42081?w=400&h=300&fit=crop",
    category: "SPED",
    grades: "K-5"
  },
  {
    id: 4,
    title: "Tracing & Vocabulary Bundle",
    description: "Combined tracing and vocabulary practice for fine motor skill development.",
    price: "$5.99",
    image: "https://images.unsplash.com/photo-1513542789411-b6a5d4f31634?w=400&h=300&fit=crop",
    category: "Vocabulary",
    grades: "PreK-1"
  },
  {
    id: 5,
    title: "Homeschool Language Arts Pack",
    description: "Complete language arts curriculum supplement for homeschool families.",
    price: "$8.99",
    image: "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=400&h=300&fit=crop",
    category: "Homeschool",
    grades: "K-3"
  },
  {
    id: 6,
    title: "Interactive Word Games Set",
    description: "Fun, printable word games that make learning vocabulary exciting and engaging.",
    price: "$4.49",
    image: "https://images.unsplash.com/photo-1516979187457-637abb4f9353?w=400&h=300&fit=crop",
    category: "Activities",
    grades: "1-3"
  }
];

export const amazonProducts = [
  {
    id: 1,
    title: "Vocabulary Workbook for Kids & Teachers - Spacious Edition",
    description: "Embrace the Magic of Words: A comprehensive vocabulary workbook designed to support all learners including SPED, ESL, ELL, homeschool, and early elementary students.",
    price: "Check Amazon",
    image: "https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=400&h=300&fit=crop",
    amazonLink: "https://www.amazon.com/Vocabulary-Workbook-Kids-Teachers-Spacious/dp/B0GZ5Y3GZZ",
    rating: 4.8,
    reviews: 124
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Sarah Johnson",
    role: "3rd Grade Teacher",
    content: "These resources have transformed my vocabulary lessons! My students are more engaged than ever.",
    rating: 5
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "ESL Specialist",
    content: "Perfect for my ELL students. The tracing activities really help with word retention and confidence.",
    rating: 5
  },
  {
    id: 3,
    name: "Emily Rodriguez",
    role: "Homeschool Parent",
    content: "Easy to use and incredibly effective. My kids actually look forward to vocabulary practice now!",
    rating: 5
  }
];

export const features = [
  {
    title: "Multi-Learner Support",
    description: "Designed for SPED, ESL, ELL, homeschool, and early elementary students."
  },
  {
    title: "Tracing Activities",
    description: "Build fine motor skills while learning vocabulary through engaging tracing exercises."
  },
  {
    title: "Printable & Ready",
    description: "All materials are print-ready and easy to use for educators and families."
  },
  {
    title: "Confidence Building",
    description: "Progressive activities designed to build language confidence one word at a time."
  }
];